<template>
  <v-sheet class="bg-background flex-1-1 px-4" max-width="800">
    <v-form v-model="isFormValid" @submit.prevent>
      <v-sheet class="border-opacity-25 border-thin rounded-lg overflow-hidden pa-5">
        <v-text-field
          v-model="formTemplate.name"
          label="Name"
          :rules="[rules.required]"></v-text-field>

        Body
        <Editor
          v-model="formTemplate.body"
          :init="{
            base_url: '/tinymce',
            suffix: '.min',
            plugins: 'lists link image table code',
            toolbar:
              'undo redo | blocks | bold italic | alignleft aligncenter alignright | bullist numlist | link image table | code',
            skin: 'oxide',
            content_css: 'default',
          }"
          licenseKey="gpl"></Editor>
      </v-sheet>
      <v-alert v-if="apiError" type="error" class="mt-3">{{ apiError }}</v-alert>

      <br />
      <v-btn
        color="primary"
        block
        class="rounded-lg mb-8"
        elevation="2"
        :disabled="!isFormValid"
        @click="saveFormTemplate"
        >Save Form Template</v-btn
      >
    </v-form>
  </v-sheet>
</template>
<script setup lang="ts">
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { rules } from '@/helpers';
import Editor from '@tinymce/tinymce-vue';
import { FormTemplateDTO, IFormTemplateDTO } from '@/dtos';
import { useFormTemplateStore } from '@/stores/modules';
import { SNACKSTATUS } from '@/stores/util';
import { useUpdateStatusStore } from '@/stores/modules';
import '@/components/tinymce/tinymce';
const route = useRoute();
const formTemplateId = ref(
  Array.isArray(route.params.formTemplateId)
    ? route.params.formTemplateId[0]
    : (route.params.formTemplateId ?? ''),
);
const emit = defineEmits(['snack']);
const formTemplateStore = useFormTemplateStore();
const statusStore = useUpdateStatusStore();
const formTemplate = ref<IFormTemplateDTO>(new FormTemplateDTO());
const isFormValid = ref<boolean>(false);
const apiError = ref<string | undefined>(undefined);

watch(
  () => statusStore.getStatus(`form-template-${formTemplateId.value}`),
  (value: SNACKSTATUS | undefined) => {
    if (!value) {
      return;
    }
    const key = `form-template-${formTemplateId.value}`;
    emit('snack', 'Form Template', value, statusStore.getError(key));
  },
);

const { data: formData } = formTemplateStore.getFormTemplateById(formTemplateId);

watch(formData, () => {
  formTemplate.value = new FormTemplateDTO(formData.value);
});

const saveFormTemplate = async () => {
  formTemplateStore.update.mutateAsync(formTemplate.value);
};
</script>
